<template>
	<div class="wrap">

		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item class="test" :to="{ path: '/lianxiwomen' }">加入我们设置</el-breadcrumb-item>
			<el-breadcrumb-item>添加招聘岗位</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card>
			<el-form label-width="80px" :model="formData">
				<!-- :label-position="labelPosition" :model="formLabelAlign" -->
				<el-form-item label="岗位权重">
					<el-input v-model="formData.weights" style="width: 70px;" type="number"></el-input>
					<el-tag style="margin-left: 20px;" type="danger">权重越高，排序越靠前</el-tag><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="职位">
					<el-input v-model="formData.name"></el-input>
				</el-form-item>
				<el-form-item label="岗位类型">
					<el-input v-model="formData.type"></el-input>
				</el-form-item>
				<el-form-item label="所属部门">
					<el-input v-model="formData.departmentName"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="地址">
					<el-input v-model="formData.address"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="岗位详情">
					<!-- 图片上传组件辅助-->
					<el-upload class="avatar-uploader" :action="uploadUrl" type="drag" :show-file-list="false" :on-success="uploadSuccess">
					</el-upload>
					<!-- 富文本编辑器 -->
					<quill-editor v-model="formData.quillData" :options="editorOption" ref="myref"></quill-editor>
				</el-form-item>

			</el-form>

			<!-- 添加商品 -->
			<el-button type="success" class="submitBtn" @click="submit">立即提交</el-button>
		</el-card>

	</div>
</template>

<script>
	const toolbarOptions = [
		['bold', 'italic', 'underline', 'strike'], // toggled buttons
		['blockquote', 'code-block'],

		[{
			'header': 1
		}, {
			'header': 2
		}], // custom button values
		[{
			'list': 'ordered'
		}, {
			'list': 'bullet'
		}],
		[{
			'script': 'sub'
		}, {
			'script': 'super'
		}], // superscript/subscript
		[{
			'indent': '-1'
		}, {
			'indent': '+1'
		}], // outdent/indent
		[{
			'direction': 'rtl'
		}], // text direction

		[{
			'size': ['12px', '14px', false, '18px', '22px', '26px', '30px', '36px', '42px']
		}], // custom dropdown
		[{
			'header': [1, 2, 3, 4, 5, 6, false]
		}],

		[{
			'color': []
		}, {
			'background': []
		}], // dropdown with defaults from theme
		[{
			'font': []
		}],
		[{
			'align': []
		}],
		['link', 'image', 'video'],
		['clean'] // remove formatting button
	]
	import {
		quillRedefine
	} from 'vue-quill-editor-upload' //引入图片上传
	
	import ImageResize from 'quill-image-resize-module'
	Quill.register('modules/imageResize', ImageResize) 
	
	export default {
		components: {

		},
		data() {
			return {
				uploadUrl: this.$httpTitle + '/uploadImgQiniugroup?pathName=activityNewInfo',
				/* fileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}], */
				fileList: [],
				fileList2: [],
				id: '',
				detailData: {},
				quillData: '',
				formData: {
					weights: '',
					mame:'',
					type: '',
					departmentName: '',
					address: '',
					quillData: '',
					introduction: '',

				},

				editorOption: {
					theme: 'snow', // or 'bubble'
					modules: {
						imageResize: { //放大缩小
							displaySize: true
						},
						toolbar: {
							container: toolbarOptions, // 工具栏
							handlers: {
								'image': function(value) {
									if (value) {
										// 触发input框选择图片文件
										document.querySelector('.avatar-uploader input').click()
									} else {
										this.quill.format('image', false);
									}
								}
							}
						}
					}
				},

			}
		},
		created() {
			var that = this
			setTimeout(function() {
				console.log(that.$refs.myref.quill)
			}, 100)
		},
		methods: {
			onRemove(file, fileList) {
				console.log('fileList=' + JSON.stringify(fileList))
				this.fileList2 = [];
			},
			onSuccess(res) {
				console.log('res=' + JSON.stringify(res))
				this.fileList2.push(res)
			},

			uploadSuccess(res, file) { // res为图片服务器返回的数据
				var that = this
				console.log('uploadSuccess res=' + JSON.stringify(res))
				setTimeout(function() {
					console.log("194=" + that.$refs.myref)
					let quill = that.$refs.myref.quill;

					if (res) {
						let length = quill.getSelection().index; // 获取光标所在位置
						quill.insertEmbed(length, 'image', that.$imgTitle + res); // 插入图片  res.info为服务器返回的图片地址
						quill.setSelection(length + 1); // 调整光标到最后
					} else {
						that.$message.error('图片插入失败')
					}
					that.quillUpdateImg = false; // loading动画消失
				}, 0)

			},
			async submit() {
				/* 4.在招岗位新增/v1/official/manag/recruitment/job/add  
				post请求 参数 String jobType,String jobName,String positionType,String positionName,
				String departmentType,String departmentName,String address,String content,Integer weights */
				//console.log(this.quillData)
				var obj = {};
				obj['jobType'] = this.formData.type 
				obj['jobName'] = this.formData.type  
				obj['positionType'] = 1
				obj['positionName'] = this.formData.name
				obj['departmentType'] = 1
				obj['departmentName'] = this.formData.departmentName 
				obj['address'] = this.formData.address 
				obj['content'] = this.formData.quillData 
				obj['weights'] = +this.formData.weights 
				
				console.log(JSON.stringify(obj))
				
				if (obj.weights == '' || obj.jobType == '' || obj.jobName == '' || obj.address =='' || obj.content =='' || obj.departmentName == '') {
					return this.$message.error('请添加必要的参数!')
				}
				
				const res = await this.$http.post('/v1/official/manag/recruitment/job/add', {
					request: obj
				})
				console.log('res=' + JSON.stringify(res))
				if (res.data.code == 0) {
					this.$message.success('添加成功')
					this.$router.push({
						path: '/lianxiwomen'
					})
				} else {
					this.$message.error(res.data.message)
				}

			}
		}
	}
</script>

<style lang="less" scoped>
	.el-card {
		/* width: 1000px; */
	}

	.submitBtn {
		margin: 0 auto;
		margin-top: 90px;
		margin-left: 80px;
	}
</style>
